import { isComponentPotentiallySkippable } from './conditionality';

const isPagePotentiallySkipped = (pageNumber, components, pages) => {
  const componentIds = pages[pageNumber];
  return (
    Array.isArray(componentIds) &&
    componentIds.length > 0 &&
    componentIds.every((componentId) =>
      isComponentPotentiallySkippable(components[`component_${componentId}`])
    )
  );
};

export const getFinalConfirmedShownPage = ({
  components,
  submissionPageNumber,
  pages,
}) => {
  const finalPageNumber = submissionPageNumber || pages.length - 1;
  for (let pageNumber = finalPageNumber; pageNumber >= 0; pageNumber -= 1) {
    if (!isPagePotentiallySkipped(pageNumber, components, pages)) {
      return pageNumber;
    }
  }
  return 0;
};

export const getPotentialSubmissionPages = ({
  components,
  submissionPageNumber,
  pages,
  pageNumbers,
}) => {
  const finalConfirmedPage = getFinalConfirmedShownPage({
    components,
    submissionPageNumber,
    pages,
  });
  return pageNumbers.filter((pageNumberString) => {
    const pageNumber = parseInt(pageNumberString, 10);
    return (
      pageNumber >= finalConfirmedPage &&
      (typeof submissionPageNumber !== 'number' ||
        pageNumber <= submissionPageNumber)
    );
  });
};

export const isPostSubmissionPage = ({ pageNumber, submissionPageNumber }) =>
  typeof submissionPageNumber === 'number' && pageNumber > submissionPageNumber;
